import { React, RefObject } from "react";
import {
  Form,
  Input,
  Button,
  Dialog,
  TextArea,
  Selector,
  Slider,
  Stepper,
  Switch,
} from "antd-mobile";
import styles from "./Edit.module.css"
import EditFilter from "./EditFilter.js"

const states = require("../../../utils/states.js")


const marks = {
  1: 1,
  2: 2,
  3: 3,
  4: 4,
  5: 5
}


//props.submit(word)  word 为null则取消,word为非null则提交
export default (props) => {
  console.warn('props.word = ', props.word);
  const onFinish = (values) => {
    if (!values.level) values.level = 1
    const word = values
    states.wordWrap.cur_edit_word = { ...values }
    console.warn('提交的word = ', word, 'order ', props.order)
    props.submit(word, props.order)
  }

  const onCanceled = () => {
    props.submit(null)
  }


  return (<div className={styles.addGramma}>

    <Form mode='card' className={styles.addForm}
      initialValues={{
        id: props.word.id,
        kana: props.word.kana || '',
        word: props.word.word,
        definition: props.word.definition || '',
        note: props.word.note || '',
        level: props.word.level
      }}
      onFinish={onFinish}
      layout='horizontal'
      footer={<div style={{ display: 'flex' }}>
        <Button style={{ 'flex': 1, 'marginRight': '5px' }} size='large' onClick={onCanceled}>
          取消</Button>
        <Button style={{ 'flex': 1, 'marginLeft': '5px' }}
          type='submit' color='primary' size='large'>
          提交</Button>
      </div>
      }
    >
      <div className={styles.formList}>
        <Form.Header>添加一条word</Form.Header>
        <Form.Item name='id' label='修改word'>
        </Form.Item>
        <Form.Item name='kana' label='假名'>
          <Input placeholder='假名' />
        </Form.Item>
        <Form.Item name='word' label='词汇'
          rules={[{ required: true, message: '词汇不能为空' }]}>
          <Input placeholder='词汇' />
        </Form.Item>
        <Form.Item name='definition' label='解释'>
          <TextArea
            placeholder='请输入解释'
            maxLength={50} rows={2} showCount />
        </Form.Item>
        <Form.Item name='note' label='笔记'>
          <TextArea
            placeholder='笔记区域'
            maxLength={100} rows={2} showCount />
        </Form.Item>
        <Form.Item name='level' label='等级'>
          <Slider style={{ '--fill-color': 'var(--adm-color-default)' }} marks={marks} ticks step={1} min={1} max={5} popover />
        </Form.Item>

        <div name='tag' label='tag' style={{ padding: '15px' }}>
          tag
          <EditFilter listShell={states.wordTagWrap} formerList={props.word.tags} />
        </div>
      </div>
    </Form>

  </div>)
}